import { ReactElement, useContext } from "react";
import { Spinner } from "@justworkshr/milo-core";

import { MFA_FACTOR_COPY } from "../../constants/factorCopy";

import { Factor } from "types/factor/factor";

import TotpQrCodeContext from "../../contexts/TotpQrCodeContext";

import SecretKey from "./secretKey/SecretKey";

import styles from "./totp-setup.module.css";

const TotpSetup = ({ factor }: { factor: Factor }): ReactElement => {
  const { qrCodeData } = useContext(TotpQrCodeContext);
  const copy = MFA_FACTOR_COPY[factor.key];

  const qrCodeHref = qrCodeData?._links?.qrcode?.href ?? "";

  return (
    <>
      <div className={styles.header}>Download the app and scan the QR code</div>

      <div className={styles.setupDetails}>{copy.setUpDetails}</div>

      <div className={styles.qrCode}>
        {qrCodeHref ? (
          <img src={qrCodeHref} alt={`${factor.provider} qr code`} />
        ) : (
          <Spinner />
        )}
      </div>

      <SecretKey secretKey={qrCodeData?.sharedSecret} />
    </>
  );
};

export default TotpSetup;
